import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.$navItems = this.$('navItem');

        this.events = {
            click: {
                navItem: 'change'
            }
        }
    }

    init() {

        this.swiper = new Swiper(this.$('slider')[0], {
            speed: 800,
            effect: 'fade',
            auto: false,
            allowTouchMove: false
        });

        this.$navItems[0].classList.add('is-active');
    }

    change(e) {
        let index = parseInt(e.currentTarget.getAttribute('data-index')) - 1;
        
        this.$navItems.forEach(($navItem, navIndex) => {
            $navItem.classList.remove('is-active');

            if(navIndex == index) {
                $navItem.classList.add('is-active');
            }
        });

        this.swiper.slideTo(index);
    }
}
